import axios from 'axios'
import { Toast } from 'vant'
import request from '@/utils/request'

export function ossToken (params) {
  return request({
    url: '/common/oss/token/',
    method: 'get',
    params
  })
}

export function uploadImageToOss (url, data) {
  const instance = axios.create()
  instance.interceptors.response.use(
    response => response,
    error => {
      console.log('oss err' + error) // for debug
      Toast('上传失败!')
      return Promise.reject(error)
    }
  )

  return instance({
    url,
    data,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// export function uploadBase64Image (data) {
//   let config = {
//     headers: { 'Content-Type': 'multipart/form-data' }
//   }

//   return request({
//     url: '/common/image/base64/upload/',
//     method: 'post',
//     config,
//     data
//   })
// }

// export function uploadImage (data) {
//   let config = {
//     headers: { 'Content-Type': 'multipart/form-data' }
//   }

//   return request({
//     url: '/common/image/upload/',
//     method: 'post',
//     config,
//     data
//   })
// }

// export function uploadImageMulti (data) {
//   let config = {
//     headers: { 'Content-Type': 'multipart/form-data' }
//   }

//   return request({
//     url: '/common/image/upload/multi/',
//     method: 'post',
//     config,
//     data
//   })
// }
